export const getRootDomain = () => {
  const { hostname } = window.location;
  const parts = hostname.split(".");

  let domain;
  if (hostname.includes("localhost")) {
    domain = "localhost:8788";
    return `http://${domain}`;
  }

  if (hostname.endsWith(".pages.dev")) {
    domain = parts.slice(parts.length - 4).join(".");
  } else if (parts.length > 2) {
    domain = parts.slice(parts.length - 2).join(".");
  } else {
    domain = hostname;
  }

  return `https://${domain}`;
};
